import PropTypes from 'prop-types'
import BaseButton from "./Button.jsx"

export default function SecondaryRoundedButton({children, ...props}) {
  return (
    <BaseButton color={"btn btn btn-outline btn-round btn-sm"} {...props}>
      {children}
    </BaseButton>
  )
}

SecondaryRoundedButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  className: PropTypes.string,
  type: PropTypes.string
}